import { Component } from '@angular/core';
import { Platform ,AlertController,ModalController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { HandlerService } from './handler.service';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { AdsFetchService } from './ads-fetch.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Router ,RoutesRecognized} from '@angular/router';
import { Location } from '@angular/common';
import { auth } from 'firebase';
import { AuthService } from './auth.service';
import { filter, pairwise } from 'rxjs/operators';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { SplashComponent } from './splash/splash.component';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})


export class AppComponent {
  slideOpts = {
    grabCursor:true,
    slidesPerView:1,
    centeredSlides:true,
    spaceBetween:4,
    initialSlide: 1,
    autoplay:true,
    speed: 500
  };
  allAds:any = []
  isHideFooter:boolean = false;
  url;
  showSplash:boolean=true;
  itemTypeId;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public handler:HandlerService,
    public auth: AuthService,
    public keyboard: Keyboard,
    public ad: AdsFetchService,
    private iab: InAppBrowser,
    private LocationAccuracy: LocationAccuracy,
    public router: Router,
    public modalCtrl: ModalController,
    private _location: Location,
    public alertController: AlertController,
    private push:Push
  ) {
    
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(async() => {
      const splash = await this.modalCtrl.create({
        component:SplashComponent
      });
      splash.present();
     
      setTimeout(() => {
        this.statusBar.styleBlackOpaque();
        this.splashScreen.hide();
        const options: PushOptions = {
          ios: {
              alert: 'true',
              badge: true,
              sound: 'true'
          }
       }
       if(this.platform.is('ios')){
        this.push.init(options)
       }
        localStorage.setItem("customer",'true')
        localStorage.setItem('hashKey','393544e073603057fd029eb38f21931216f57af468011543707166bc541123309916b27e4058f5aa7355f99ec0e4371dd5ae9b65169f54798bdcff67e6640514');
        this.keyboard.onKeyboardShow().subscribe(()=>{
          this.isHideFooter=true;
        })
        this.backHndler();
        this.findPreviousUrl();
        // this.turnOnGps();
        this.keyboard.onKeyboardHide().subscribe((result)=>{
          this.isHideFooter=false;
        })
      }, 500);
    
    });
    if(sessionStorage.getItem('itemTypeId')){
      this.itemTypeId=sessionStorage.getItem('itemTypeId')
    }
  }

  findPreviousUrl(){
    this.router.events
    .pipe(filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
    ).subscribe((e: any) => {
      var x = e[0].urlAfterRedirects;
      this.handler.previousUrl = x.split('/');
    });
  }

  backHndler(){
    this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
      if (this._location.isCurrentPathEqualTo('/bookservice1') || this._location.isCurrentPathEqualTo('/bookservice') ||  this._location.isCurrentPathEqualTo('/set-location')
      || this._location.isCurrentPathEqualTo('/requests')|| this._location.isCurrentPathEqualTo('/vendor-request')|| this._location.isCurrentPathEqualTo('/vendor-manage-order')) {
        this.showExitConfirm();
         processNextHandler();
      }
      else if (this._location.isCurrentPathEqualTo('/req-booking')) {
        this.router.navigate(['/edit-services'])
      } else if (this._location.isCurrentPathEqualTo('/review-items')) {
        this.router.navigate(['/req-booking'])
      }else if (this._location.isCurrentPathEqualTo('/order-payment')) {
        if(sessionStorage.getItem('handler')){
          this.handler.staticError('Yours booking will be confirmed once the payment is complete.Please visit Bookings-Saved orders to make payment and complete your service booking.')
        }       
        this.router.navigate(['/bookservice1'])
      } else if (this._location.isCurrentPathEqualTo('/PASS') || this._location.isCurrentPathEqualTo('/success')) {
        this.router.navigate(['/bookservice1'])
      }else if (this._location.isCurrentPathEqualTo('/FAIL') || this._location.isCurrentPathEqualTo('/failure') ) {
        this.router.navigate(['/order-payment'])
      }else if (this._location.isCurrentPathEqualTo('/pending')) {
        this.router.navigate(['/bookservice1'])
      }else if (this._location.isCurrentPathEqualTo('/profile1')) {
          this.router.navigate(['/bookservice1']) 
      }else if (this._location.isCurrentPathEqualTo('/profile')){
          this.router.navigate(['/bookservice'])      
      }else if (this._location.isCurrentPathEqualTo('/mybookings1')){
        this.router.navigate(['/bookservice1'])      
      }else if (this._location.isCurrentPathEqualTo('/mybookings')){
         this.router.navigate(['/bookservice'])      
      }else if (this._location.isCurrentPathEqualTo('/customerCare1')){
         this.router.navigate(['/bookservice1'])      
      }else if (this._location.isCurrentPathEqualTo('/customerCare')){
         this.router.navigate(['/bookservice'])      
      }else if (this._location.isCurrentPathEqualTo('/validateProfile')) {
        this.router.navigate(['/profile'])
      }else if (this._location.isCurrentPathEqualTo('/subservice1') || this._location.isCurrentPathEqualTo('/edit-services')  ) {
        this.router.navigate(['/bookservice1'])
      }else if (this._location.isCurrentPathEqualTo('/subservice') ) {
        this.router.navigate(['/bookservice'])
      }else if (this._location.isCurrentPathEqualTo('/validateForOrder')) {
        sessionStorage.setItem('itemTypeId',this.itemTypeId)
        sessionStorage.setItem('dummyValue','true')
        this.router.navigate(['/subservice'])
      }else if (this._location.isCurrentPathEqualTo('/employeeCheck')) {
        this.router.navigate(['/vendor-register'])
      }else if(this._location.isCurrentPathEqualTo('/vendorCategory') || this._location.isCurrentPathEqualTo('/employeeReg')){
        this.router.navigate(['/vendor-register'])
      }
      else if(this._location.isCurrentPathEqualTo('/choose-category') || this._location.isCurrentPathEqualTo('/register')){
        this.router.navigate(['/vendor-register'])
      }
      else if(this._location.isCurrentPathEqualTo('/contractorReg')){
        this.router.navigate(['/vendor-register'])
      }
      else if(this._location.isCurrentPathEqualTo('/admin-manage-order')){
        this.router.navigate(['/admin'])
      }
    //new route starts
    else if(this._location.isCurrentPathEqualTo('/home-Vendor-invoice')||this._location.isCurrentPathEqualTo('/home-record-pay')||this._location.isCurrentPathEqualTo('/homeVendorAssign')||this._location.isCurrentPathEqualTo('/homeContractorAssign')|| this._location.isCurrentPathEqualTo('/order-requests')||this._location.isCurrentPathEqualTo('/home-order-edit')||this._location.isCurrentPathEqualTo('/home-new-order')||this._location.isCurrentPathEqualTo('/homeCategories')||this._location.isCurrentPathEqualTo('/homeChangeVendorAssign')){
      this.router.navigate(['/vendor-manage-order'])
    }
    else if(this._location.isCurrentPathEqualTo('/homeNewOrder')){
      this.router.navigate(['/homeCategories'])
    }
    else if(this._location.isCurrentPathEqualTo('/Vendor-invoice')||this._location.isCurrentPathEqualTo('/record-pay')||this._location.isCurrentPathEqualTo('/vendorAssign')||this._location.isCurrentPathEqualTo('/contractorAssign')|| this._location.isCurrentPathEqualTo('/manageRequest')||this._location.isCurrentPathEqualTo('/initial-order-edit')||this._location.isCurrentPathEqualTo('/vendor-new-order')||this._location.isCurrentPathEqualTo('/newCategories') ||this._location.isCurrentPathEqualTo('/changeAssignVendor')  ){
      this.router.navigate(['/admin-manage-order'])
    }
    else if(this._location.isCurrentPathEqualTo('/createNewOrder')){
      this.router.navigate(['/newCategories'])
    }
      else if (this._location.isCurrentPathEqualTo('/vendorAdminProfile')) {
        if(this.auth.checkCapability('SC')){
          this.router.navigate(['/requests'])
        }else{
          this.router.navigate(['/vendor-request'])
        }
     
      }
      else {
        console.log('Navigate to back page');
        this._location.back();
      }
    });

    this.platform.backButton.subscribeWithPriority(5, () => {
      console.log('Handler called to force close!');
      this.alertController.getTop().then(r => {
        if (r) {
          navigator['app'].exitApp();
        }
      }).catch(e => {
        
      })
    });

  }

  turnOnGps() {
  this.LocationAccuracy.request(this.LocationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
  }

  showExitConfirm() {
    this.alertController.create({
      message: 'Do you want to close the app?',
      backdropDismiss: false,
      buttons: [{
        text: 'Stay',
        role: 'cancel',
        handler: () => {
          console.log('Application exit prevented!');
        }
      }, {
        text: 'Exit',
        handler: () => {
          navigator['app'].exitApp();
        }
      }]
    })
      .then(alert => {
        alert.present();
      });
  }

  openpage(url) {
    if (url) {
      this.iab.create(url, '_system');
        } else {
      this.handler.res('There is no URL')
    }
  }
}
